import React, { useState, useEffect } from "react";
import styles from './reviewCriteria.module.scss';
import { CustomButton } from '../../../../../shared/customButton';
import { Formik, FieldArray } from 'formik';
import { Col, Row, Form, Card, Button, Accordion, Tab, Tabs } from 'react-bootstrap';
import StarRating from '../../../../../shared/rate';
import * as yup from 'yup';
import { CustomAlertBox } from "../../../../../shared/customAlertBox";
import { CustomStarTextField } from "../../../../../shared/customStarTextField";

const AddReviewCriteria = (props) => {

    yup.addMethod(yup.array, 'unique', function (message, mapper = a => a) {
        return this.test('unique', message, function (list) {
            return list.length === new Set(list.map(mapper)).size;
        });
    })
    const schema = yup.object({
        reviewCriteria: yup.array().of(
            yup.object().shape({
                label: yup.string().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('required'),
            })
        )
            .unique('Duplicate review criterion', r => r.label)
            .min(1, 'At least one review criterion is required. Click "Add New Criteria".').required('Required'),
        reviewCriteriaToBeAdded: yup.string().when('reviewCriteria', {
            is: (reviewCriteria) => (reviewCriteria && reviewCriteria.length > 0), then: () => yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').test('duplicate subject check', 'Duplicate review criterion', function (item) {
                if ((this.parent.reviewCriteria.findIndex(obj => obj.label === item)) != -1) {
                    return false;
                } else {
                    return true;
                }
            }),
            otherwise: () => yup.string()
        }),
    });
    const onSubmit = (values) => {
        props.setAddReviewCriteria(values);
        props.nextPage(3)
    }

    const addReviewCriteria = (e, values, setValues) => {

        const reviewCriteria = [...values.reviewCriteria];

        let newReviewCriteria = {
            label: ''
        }

        reviewCriteria.push(newReviewCriteria);
        setValues({ ...values, reviewCriteria });

    }

    const removeAddiionalReviewCriteria = (e, id, values, setValues) => {
        const reviewCriteria = [...values.reviewCriteria];
        if (reviewCriteria.length !== 0) {
            let newArray = reviewCriteria.filter(function (obj, index) {
                return index !== id;
            });
            setValues({ ...values, reviewCriteria: newArray });
        }
    }

    const setObjectArray = (values) => {
        const data = {
            label: values.reviewCriteriaToBeAdded
        }
        if ((values.reviewCriteriaToBeAdded).length > 0) {
            values.reviewCriteria.push(data);
        }
    }
    return (
        <div>
            <Formik
                enableReinitialize
                validationSchema={schema}
                onSubmit={(values) => onSubmit(values)}
                initialValues={{ reviewCriteria: props.pipelineValues.reviewCriteria }}
            >
                {({
                    values,
                    errors,
                    setFieldValue,
                    touched,
                    setValues,
                    handleChange,
                    handleSubmit,
                    submitCount,
                }) => (
                    <div>
                        <Form noValidate onSubmit={handleSubmit}>
                            <div>
                                <p className={styles.subTopics}>Evaluation criteria for candidates</p>
                                {(props.values.stageType === 10) ?
                                    <div className={styles.alertDiv}>
                                        <CustomAlertBox alertType="defaultAlert" errorMessageId="adminPanel_hiringPipelines_editpipeline_addStagesModal_cvFiletrReviewCriteria_infoMessageId" alertBodyText="Candidate CV is automatically evaluated according to the keywords you entered. If the system finds the minimum number of keywords from the candidate's CV, the system will automatically move candidate to the next step. Candidates with low or no keywords found, will get rejected automatically." />
                                    </div> :
                                    (props.values.stageType === 50) ?
                                        <div className={styles.alertDiv}>
                                            <CustomAlertBox alertType="defaultAlert" errorMessageId="adminPanel_hiringPipelines_editpipeline_addStagesModal_quizReviewCriteria_infoMessageId" alertBodyText="After the candidate submits the Quiz, the system will automatically check the correct and wrong answers. Depending on the minimum pass score candidates will pass or fail." />
                                        </div> :
                                        (props.values.stageType === 60) ?
                                            <div className={styles.alertDiv}>
                                                <CustomAlertBox alertType="defaultAlert" errorMessageId="adminPanel_hiringPipelines_editpipeline_addStagesModal_referenceReviewCriteria_infoMessageId" alertBodyText="After the candidates submit the reference details, reviewers have to check the details and pass or fail candidates according to referee feedback." />
                                            </div> :
                                            <div className={styles.alertDiv}>
                                                <CustomAlertBox alertType="defaultAlert" alertBodyText="Candidates will be evaluated against these criteria. These will be the guidelines for your internal hiring team." />
                                            </div>
                                }


                                <p className={styles.reviewCriteriaErrorMsg} id="adminPanel_hiringPipelines_createPipelineModal_reviewCriteria_validationMsgId">{(errors && errors.reviewCriteria && !Array.isArray(errors.reviewCriteria)) && errors.reviewCriteria}</p>
                                {(props.values.stageType !== 10 && props.values.stageType !== 50 && props.values.stageType !== 60) && (
                                    <div>
                                        <FieldArray name="reviewCriteria">
                                            {() => (
                                                values.reviewCriteria && values.reviewCriteria.map((reviewCriteria, i) => {
                                                    const reviewCriteriaErrors = (errors.reviewCriteria?.length && errors.reviewCriteria[i]) || {};
                                                    const reviewCriteriaTouched = (touched.reviewCriteria?.length && touched.reviewCriteria[i]) || {};

                                                    return (
                                                        <div className={styles.customStarTextField} key={i}>
                                                            <CustomStarTextField
                                                                keyValue={i}
                                                                classLabel="defaultLabel"
                                                                controlId={`adminPanel_hiringPipelines_createPipelineModal_reviewCriteria_addReviewCriteriaFieldId.${i}`}
                                                                type="text"
                                                                value={(values && values.reviewCriteria && values.reviewCriteria[i]) && values.reviewCriteria[i].label}
                                                                handleOnChange={handleChange}
                                                                name={`reviewCriteria.${i}.label`}
                                                                classType="defaultTextBox"
                                                                onCancelClick={(e) => removeAddiionalReviewCriteria(e, i, values, setValues)} id={`adminPanel_hiringPipelines_createPipelineModal_reviewCriteriaSkillDeleteBtnId.${i}`}
                                                                errorMessage={(errors && errors.reviewCriteria && errors.reviewCriteria[i]) && errors.reviewCriteria[i].label}
                                                                validationMsgId="adminPanel_hiringPipelines_createPipelineModal_reviewCriteriaValidationMsgId"
                                                                isInvalid={(errors && errors.reviewCriteria && errors.reviewCriteria[i]) ? true : false}
                                                                isCancelable={true}
                                                            />
                                                        </div>
                                                    );
                                                })
                                            )}
                                        </FieldArray>

                                        <CustomButton
                                            id="adminPanel_hiringPipelines_createPipelineModal_reviewCriteria_addNewCriteriaBtnId"
                                            buttonType="button"
                                            label="Add New Criteria"
                                            type="secondaryBtn"
                                            handleClick={(e) => addReviewCriteria(e, values, setValues)}
                                            frontIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                    <path d="M10 4.66667V16.3333M4.16669 10.5H15.8334" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            }
                                        />
                                    </div>
                                )}
                            </div>
                            <hr className={styles.dividerLine} />
                            <Row className="mt-3 d-flex flex-row-reverse">
                                <div className={styles.navigateBtnCol}>
                                    <CustomButton
                                        id="adminPanel_hiringPipelines_createPipelineModal_reviewCriteria_reviewCriteriaPageNextBtnId"
                                        buttonType="submit"
                                        label="Review"
                                        type="primaryBtn"
                                    />
                                </div>
                                <div className={styles.navigateBtnCol}>
                                    <CustomButton
                                        id="pipeline_additional_detail_cancel"
                                        buttonType="button"
                                        label="Back"
                                        type="defaultBtn"
                                        handleClick={() => props.previousPage(1)}
                                    />
                                </div>

                            </Row>
                        </Form>
                    </div>
                )}
            </Formik>
        </div>
    );
};
export default AddReviewCriteria;